/* Migrated sliders — self-contained <slider-component> for the redesign theme.
   Copied verbatim from the live theme global.js (SliderComponent), wrapped in a
   guard so it never double-defines if the theme ever ships its own. Additive: this
   is a NEW asset and does not modify any existing redesign file. */
(function () {
  if (customElements.get("slider-component")) return;

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.progresiveBar = this.querySelector('.slider-progresive-bar');
    this.dots = this.querySelectorAll('.slider-dots .slider-counter__link');

    if (!this.slider || !this.nextButton) return;

    this.initPages();

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    [...this.dots].forEach(dot => dot.addEventListener('click', this.onButtonClick.bind(this)))

    this.updateProgressiveBar()
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    // IG | Add this prop to check the correct nuber
    this.prevTotalPages = this.totalPages;
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  // IG | Custom function to update a progressive bar if it exist
  updateProgressiveBar() {
    if(!!!this.progresiveBar) return;

    this.addEventListener('slideChanged', (evt) => {
        const detail = evt.detail;
        this.progresiveBar.children[0].style.setProperty('--progressive-val-total', detail.totalPages);
        this.progresiveBar.children[0].style.setProperty('--progressive-val', detail.currentPage - 1);
    });
  }

  update() {
    if(this && this.classList.contains('section-mision__slider')) {
        const nextButton = this.querySelector('.slider-button--next')
        this.currentPage - 1 == 4 ? nextButton.classList.add('hidden') : nextButton.classList.remove('hidden')
    }
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    // IG | Snap to last page when last slide is fully visible so progressive bar reaches 100%
    const lastSlide = this.sliderItemsToShow && this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (lastSlide && this.totalPages && this.isSlideVisible(lastSlide)) {
      this.currentPage = this.totalPages;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    // IG | Add check total pages change
    if (this.currentPage != previousPage || this.prevTotalPages != this.totalPages) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        totalPages: this.totalPages,
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if ( this.dots.length > 0 ) {
        const dotsElements = [...this.dots];
        dotsElements.forEach(dot => dot.classList.remove('slider-counter__link--active'))
        dotsElements[this.currentPage - 1].classList.add('slider-counter__link--active')
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = ( event.currentTarget.classList.contains('slider-counter__link--dots') )
    ? step * this.sliderItemOffset
    : ( event.currentTarget.name === 'next' ) ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}


  customElements.define("slider-component", SliderComponent);
})();
